import cxs from 'cxs';
import { COLOURS } from '../../../common/styles/vars';

export const CONTAINER = cxs({
  background: COLOURS.mono.offwhite35,
  height: '8px',
  width: '100%',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 3
});

export const INNER_BAR = (percent) => cxs({
  background: COLOURS.cyan.jungleGreen.monkey,
  height: '100%',
  transition: 'width .5s',
  width: `${percent}%`
});


export const BLOCK_STAGE = (visible) => cxs({
  background: visible ? COLOURS.cyan.jungleGreen.monkey : COLOURS.mono.offwhite35,
  height: '6px',
  flexGrow: 1,
  transition: 'background .5s',
  borderRadius: '2px',
  margin: '0 0.3vw',
  width: '3vw'
});

export const BLOCK_CONTAINER = (position) => cxs({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  position: 'fixed',
  top: 0,
  margin: '1rem 0.9rem',
  [position === 'left' ? 'left' : 'right']: 0,
  zIndex: 3
});